<template>
    <div style="background: #f9f9f9" class="adaptiveMobileModelDetails">
        <div class="modelDeta" style="padding-bottom: 20px">
            <div class="modelDeta_loc_top">
                <p>
                    <!-- 当前位置：3D模型库>模型库详情> -->
                    <span>当前位置：</span>
                    <el-breadcrumb separator=">">
                        <el-breadcrumb-item :to="{ path: '/model' }">3D模型库</el-breadcrumb-item>
                        <!-- <el-breadcrumb-item>模型库详情</el-breadcrumb-item> -->
                        <el-breadcrumb-item>{{ modelDetail.modelName }}</el-breadcrumb-item>
                    </el-breadcrumb>
                    <!-- <span>{{ modelDetail.modelName }}</span> -->
                </p>
            </div>
            <div class="modelDeta_topBox">
                <div class="modelDeta_topBox2">
                    <div class="modelDeta_loc">
                        <p class="modelDeta_loc_title">{{ modelDetail.modelName }}</p>
                        <div
                                class="flex modelDeta_loc_titleBox"
                                style="
                width: 734px;
                justify-content: space-between;
                align-items: center;
              "
                        >
                            <p class="modelDeta_loc_time">{{ modelDetail.createDate }}</p>
                        </div>
                    </div>
                    <div class="modelDeta_top flex">
                        <div class="modelDeta_top_imgs">
                            <div class="modelDeta_swiper" style="position: relative">
                                <el-carousel
                                        trigger="click"
                                        height="412px"
                                        arrow="always"
                                        @change="swiperChange"
                                        ref="carouselRef"
                                >
                                    <el-carousel-item
                                            v-for="(item, index) in swiperList"
                                            :key="index"
                                    >
                                        <img :src="item.url" style="width: 100%; height: 100%"/>
                                        <div
                                                class="changeType"
                                                @click="changeType(item, 'model')"
                                                v-if="item.fileType === 'FILE'"
                                        >
                                            <img src="../../assets/模型库/3DIcon.png" alt=""/>
                                            <span>3D场景</span>
                                        </div>
                                    </el-carousel-item>
                                </el-carousel>
                                <div class="toolBars">
                                    <ul>
                                        <li>
                                            <i
                                                    v-if="!like"
                                                    @click="liked(modelDetail.uuid)"
                                                    class="el-icon-star-off"
                                            ></i>
                                            <i
                                                    v-if="like"
                                                    @click="liked(modelDetail.uuid)"
                                                    class="el-icon-star-on"
                                                    style="color: #e6a23c; font-size: 24px"
                                            ></i>
                                            <span>{{ modelDetail.collectionNum }}</span>
                                        </li>
                                        <li>
                                            <i
                                                    v-if="!modelDetail.fabulousLike"
                                                    class="iconfont"
                                                    style="margin-right: 8px; cursor: pointer;z-index: 9;"
                                                    @click="saveNewsFabulous"
                                            >&#xe665;</i
                                            >
                                            <i
                                                    v-if="modelDetail.fabulousLike"
                                                    class="iconfont"
                                                    style="
                          margin-right: 8px;
                          color: #e6a23c;
                          cursor: pointer;
                          position: relative;
                          z-index: 9;
                        "
                                                    @click="deleteNewsFabulous"
                                            >&#xe639;</i
                                            >
                                            <span>
                        {{
                          modelDetail.likeNum == null ? 0 : modelDetail.likeNum
                        }}
                      </span>
                                        </li>
                                        <li class="flex">
                                            <!-- <i class="iconfont icon-weixin">
                                                                      <share :config="config" style="z-index: 99999999;"></share>
                                                                  </i> -->
                                            <share :config="config" class="shareHover"></share>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="modelDeta_thumbnailImg">
                                <ul
                                        ref="thumbnailImgUlRef"
                                        v-if="swiperList.length <= 4"
                                        style="width: 100%"
                                >
                                    <li
                                            v-for="(item, index) in swiperList"
                                            :key="index"
                                            :class="swiperIndex === index ? 'active' : ''"
                                            @click="thumbnailImgChange(index)"
                                            :style="
                      swiperList.length === 4
                        ? index === 3
                          ? 'margin-right: 0;'
                          : 'margin-right: 15px;'
                        : 'margin-right: 15px;'
                    "
                                    >
                                        <img :src="item.url" style="width: 100%; height: 100%"/>
                                    </li>
                                </ul>
                                <el-scrollbar
                                        style="height: 120px; width: 100%"
                                        ref="thumbnailImgRef"
                                        v-if="swiperList.length > 4"
                                >
                                    <ul ref="thumbnailImgUlRef">
                                        <li
                                                v-for="(item, index) in swiperList"
                                                :key="index"
                                                :class="swiperIndex === index ? 'active' : ''"
                                                @click="thumbnailImgChange(index)"
                                                :style="
                        swiperList.length === 4
                          ? index === 3
                            ? 'margin-right: 0;'
                            : 'margin-right: 15px;'
                          : 'margin-right: 15px;'
                      "
                                        >
                                            <img :src="item.url" style="width: 100%; height: 100%"/>
                                        </li>
                                    </ul>
                                </el-scrollbar>
                            </div>
                        </div>
                        <!-- 右边 -->
                        <div class="modelDeta_top_content">
                            <!-- 设计师 -->
                            <div class="flex top_user">
                                <div class="flex" style="position: relative">
                                    <img :src="designer.iconUrl" alt="" v-if="designer.iconUrl"/>
                                    <img src="../../assets/users.png" alt="" v-else/>
                                    <img
                                            v-if="designer.sex == 'MALE'"
                                            src="../../assets/模型库/sexIcon.png"
                                            style="
                      width: 40px;
                      height: 40px;
                      position: absolute;
                      left: 36px;
                      top: 40px;
                    "
                                    />
                                    <img
                                            v-if="designer.sex == 'FEMALE'"
                                            src="../../assets/模型库/sexIcon1.png"
                                            style="
                      width: 40px;
                      height: 40px;
                      position: absolute;
                      left: 36px;
                      top: 40px;
                    "
                                    />
                                    <img
                                            v-if="designer.sex == 'SECRET'"
                                            src="../../assets/模型库/sexIcon2.png"
                                            style="
                      width: 40px;
                      height: 40px;
                      position: absolute;
                      left: 36px;
                      top: 40px;
                    "
                                    />
                                    <div class="top_userName">
                                        <p style="width: 300px;">
											<!-- <span> {{ designer.nickname }}</span> -->
                                           {{ designer.nickname }}
                                            <img
                                                    v-for="(item, index) in designerLevelList"
                                                    :key="index"
                                                    :src="item.levelIconUrl?item.levelIconUrl:require('../../assets/模型库/designIcon.png')"
                                                    :title="item.name"
                                                    class="top_userName_userName"
                                            />
                                        </p>
                                        <div class="flex" style="display: flex;align-items: center;">
                      <span>{{ designer.introduction }}</span
                      ><br/>
                                            <div class="flex" style="display: flex;align-items: center;">
                                                <button @click="getDesigner(designer.uuid)">
                                                    主页
                                                </button>
                                                <button @click="startChat">联系</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 模型描述 -->
                            <div class="modelDes">
                                <h4>模型描述</h4>
                                <p class="modelDes_mess">
                                    {{ modelDetail.remark }}
                                </p>
                                <div class="modelDes_money">
                                    <h2 v-if="modelDetail.attribute == 'PAY'">
                                        {{ "¥" + modelDetail.price }}
                                    </h2>
                                </div>
                                <el-button
                                        v-if="modelDetail.attribute == 'PAY' && mine == 0"
                                        @click="orderDownLoad"
                                >
                                    <i class="iconfont icon-xiazai" style="padding-right: 3px"></i
                                    >购买下载
                                </el-button>
                                <el-button :loading="modelDownLoading"
                                           v-if="modelDetail.attribute == 'PAY' && mine == 1"
                                           @click="handleBatchDownload"
                                >
                                    <i class="iconfont icon-xiazai" style="padding-right: 3px"
                                       v-show="!modelDownLoading"></i
                                    >{{modelDownLoading?'拼命打包中':'已付款，去下载'}}
                                </el-button>
                                <el-button
                                        v-if="modelDetail.attribute == 'PAY' && mine == 2"
                                        @click="goPay"
                                >
                                    <i class="iconfont icon-xiazai" style="padding-right: 3px"></i
                                    >已下单，去支付
                                </el-button>
                                <el-button
                                        :loading="modelDownLoading"
                                        v-else-if="modelDetail.attribute == 'FREE'"
                                        @click="orderDownLoad"
                                ><i
                                        class="iconfont icon-xiazai"
                                        style="padding-right: 3px"
                                        v-show="!modelDownLoading"
                                ></i
                                > {{modelDownLoading?'拼命打包中':'免费下载'}}
                                </el-button
                                >
                                <!--<el-button v-else disabled style="background: #ccc">
                                  <i class="el-icon-view" style="padding-right: 3px"></i
                                  >{{ modelDetail.attributeCn }}
                                </el-button>-->
                            </div>
                            <!-- 购买记录 -->
                            <div class="model_shop">
                                <h4>下载记录</h4>
                                <vue-seamless-scroll
                                        :data="purchaseRecordList"
                                        :class-option="defaultOption"
                                        ref="seamlessScroll"
                                        v-if="purchaseRecordList.length > 4"
                                        class="model_shopBIg"
                                >
                                    <div
                                            class="flex model_shop_box"
                                            v-for="(item,index) in purchaseRecordList"
                                            :key="index"
                                    >
                                        <div class="model_shop_img flex">
                                            <img :src="item.img" alt=""/>
                                            <p>{{ item.name }}</p>
                                        </div>
                                        <p class="model_shop_time">{{ item.time }}</p>
                                    </div>
                                </vue-seamless-scroll>
                                <div v-else class="model_shopBIg">
                                    <div
                                            class="flex model_shop_box"
                                            v-for="(item,index) in purchaseRecordList"
                                            :key="index"
                                    >
                                        <div class="model_shop_img flex">
                                            <img
                                                    :src="item.img?item.img:'../../assets/设计市场/头像1.jpeg'"
                                                    alt=""
                                            />
                                            <p>{{ item.name }}</p>
                                        </div>
                                        <p class="model_shop_time">{{ item.time }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 评价 -->
            <div class="modelDeta_center">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="模型详情" name="first">
                        <div class="modelDeMess">
                            <p v-if="modelDetail.modelDes" v-html="modelDetail.modelDes" class="vHtmlMess"></p>
                            <p v-else>暂无详情</p>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="评价列表" name="second">
                        <div v-if="conmmentList.length != 0" v-loading="loading">
                            <div class="flex right_sortbox">
                                <p
                                        :class="sortboxIndex == index ? 'p_active' : ''"
                                        v-for="(items, index) in sortBox"
                                        :key="index"
                                        @click="getSortBox(index)"
                                >
                                    {{ items.name }} ({{ items.num }})
                                </p>
                            </div>
                            <div v-for="(items, index) in conmmentList" :key="index">
                                <div class="comList flex">
                                    <div class="flex">
                                        <div class="comList_img">
                                            <img :src="items.image" alt=""/>
                                        </div>
                                        <div class="comList_con">
                                            <p class="con_title">{{ items.title }}</p>
                                            <p class="con_mess">
                                                {{ items.messages }}
                                            </p>
                                            <span> {{ items.time }}</span>
                                        </div>
                                    </div>

                                    <div class="comList_star">
                                        <div class="comList_star_A flex">
                                            <span>描述相符</span>
                                            <el-rate
                                                    v-model="items.designerStar"
                                                    disabled
                                                    :colors="colors"
                                            >
                                            </el-rate>
                                        </div>
                                        <div class="comList_star_A flex">
                                            <span>服务态度</span>
                                            <el-rate
                                                    v-model="items.designerStar2"
                                                    disabled
                                                    :colors="colors"
                                            >
                                            </el-rate>
                                        </div>
                                        <div class="comList_star_A flex">
                                            <span>专业程度</span>
                                            <el-rate
                                                    v-model="items.designerStar3"
                                                    disabled
                                                    :colors="colors"
                                            >
                                            </el-rate>
                                        </div>
                                    </div>
                                </div>
                                <!-- 回复 -->
                                <div v-if="items.reply" class="additional_evaluation">
                                    设计师回复：{{ items.reply }}
                                </div>
                            </div>
                            <div style="text-align: right; padding: 0 0px 30px">
                                <el-pagination
                                        background
                                        @current-change="handleCurrentChange"
                                        @prev-click="handleCurrentChange"
                                        @next-click="handleCurrentChange"
                                        layout="total,prev, pager, next,jumper"
                                        :current-page="current"
                                        :page-size="pageSize"
                                        :total="total"
                                        class="pagination"
                                >
                                </el-pagination>
                            </div>
                        </div>
                        <div v-else class="modelDeta_centerMess" v-loading="loading">
                            暂无评价信息
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <!-- 下方列表 -->
            <div class="modelDeta_bottom">
                <p class="modelDeta_bottom_title">同类模型推荐</p>
                <div class="flex modelDeta_box_img" v-loading="modelDetaLoading">
                    <section style="padding-bottom: 30px">
                        <!-- <div style="height: 120px; margin-bottom: 30px"></div> -->
                        <el-row :gutter="30" class="content" style="margin: 0">
                            <waterfall
                                    :col="5"
                                    :width="itemWidth"
                                    :gutterWidth="gutterWidth"
                                    :data="moreList"
                                    @loadmore="loadMore"
                                    :loadDistance="100"
                            >
                                <div v-for="(items, index) in moreList" :key="index">
                                    <el-card
                                            class="box-card"
                                            shadow="always"
                                            :body-style="{ padding: '0px' }"
                                    >
                                        <el-image
                                                class="image"
                                                :src="items.imgUrl"
                                                fit="cover" style="cursor: pointer" @click="getModelDetalis(index)"
                                        ></el-image>
                                        <el-tag class="mdfree" effect="plain">
                                            {{ items.attributeCn }}
                                        </el-tag>
                                        <div
                                                style="padding: 15px; cursor: pointer"
                                        >
                                            <h4 class="mdTitle" @click="getModelDetalis(index)">
                                                {{ items.modelName|ellipsis
                                                }}<span class="mdTime">{{ items.time }}</span>
                                            </h4>
                                            <p class="mdDetail" @click="getModelDetalis(index)">{{ items.typeFirstName
                                                }}-{{ items.typeSecondName }}</p>
                                            <div class="mpNum">
                           <span
                           ><a
                           ><i class="el-icon-view" style="margin-right: 8px"></i
                           >{{ items.accessNum }}</a
                           ></span
                           >
                                                <span v-if="!items.hasLiked" @click="liked(items)"
                                                ><a href="javascript:void(0)"
                                                ><i
                                                        class="el-icon-star-off"
                                                        style="margin-right: 8px"
                                                ></i
                                                >{{ items.collectionNum }}</a
                                                ></span
                                                >
                                                <span v-if="items.hasLiked" @click="liked(items)"
                                                ><a href="javascript:void(0)"
                                                ><i
                                                        class="el-icon-star-on"
                                                        style="margin-right: 8px"
                                                ></i
                                                >{{ items.collectionNum }}</a
                                                ></span
                                                >
                                                <span
                                                ><a href="javascript:void(0)"
                                                ><i
                                                        class="el-icon-chat-dot-square"
                                                        style="margin-right: 8px"
                                                ></i
                                                >{{ items.commentsNum }}</a
                                                ></span
                                                >
                                            </div>
                                            <div class="mpFooter" @click="getDesigner(items.creatorUuid)">
                                                <div>
                                                    <el-avatar
                                                            size="medium"
                                                            :src="items.designerHead=== null?require('../../assets/headportrait.png'):items.designerHead"
                                                    ></el-avatar>
                                                </div>
                                                <span style="flex: 1; margin-left: 8px; font-size: 12px">{{
                             items.designerName
                           }}</span>
                                                <div>
                                                    <el-button @click="getModelDetalis(index)">
                                                        <i class="el-icon-download el-icon--right"></i>
                                                        {{ items.downNum }}
                                                    </el-button>
                                                </div>
                                            </div>
                                        </div>
                                    </el-card>
                                </div>
                            </waterfall>
                        </el-row>
                        <!-- <div style="text-align: right">
                                            <el-pagination
                                                style="margin-right: -10px"
                                                background
                                                layout="prev, pager, next"
                                                :total="50"
                                            >
                                            </el-pagination>
                                        </div>-->
                    </section>
                    <!--<div
                      class="modelDeta_bottom_img"
                      v-for="(item, index) in moreList"
                      :key="index"
                      @click="getModelDetalis(index)"
                    >
                      <img :src="item.imgUrl" alt="" />
                      <div class="modelDeta_bottom_Info">
                        <div style="display: flex; justify-content: space-between">
                          <div class="type">{{ item.modelName }}</div>
                          <div class="info">
                            <img
                              :src="item.designerHead?item.designerHead:require('../../assets/设计市场/头像1.jpeg')"
                              alt=""
                              class="headImg"
                            />
                            <div class="name">{{ item.designerName }}</div>
                          </div>
                        </div>
                      </div>
                    </div>-->
                </div>
            </div>
        </div>
        <!-- 3D预览 -->
        <three-d
                ref="threeBox"
                :innerVisible="innerVisible"
                :fileListNew="fileListNew"
                @closeDlog="closeDlog"
        ></three-d>
        <!--聊天窗口-->
        <chat-dialog ref="chatDialogRef"></chat-dialog>
        <!-- 购买的弹窗 -->
        <PayModelDialog ref="payModelRef"/>
    </div>
</template>

<script>
    import {
        saveModelCollection,
        getModelDetail,
        getModelList,
        addOrder,
        getModelOrderList,
        designerByUserId,
        hasLiked,
        like,
        getEvaluationList,
        getUserInfo,
        saveVisitorLog,
        getNewcurrent,
        getRongCloudUser,
        saveDesignerFabulous,
        deleteDesignerFabulous,
        designIsLike,
        getDesignLevel,
        downloadFile,
        getTagsByGoodsId
    } from "../../utils/interface";
    import vueSeamlessScroll from "vue-seamless-scroll";
    import {mapState, mapMutations} from "vuex";
    import modelView from './modelView'
    import axios from 'axios'
    import JSZip from 'jszip'
    import FileSaver from 'file-saver'
    import {getHumanDate} from "../../utils/date";
    import {ModelStl, ModelObj} from "vue-3d-model";
    import threeD from "../threeD/index";
    import chatDialog from "../chat/chatDialog";
    import QRCode from 'qrcodejs2';
    import {downLoad} from "@/utils/JSzip/downLoadModel";
    import PayModelDialog from './payModelDialog';

    export async function getFile(url) {
        return await new Promise(async function (resolve, reject) {
            await axios({
                method: 'get',
                url,
                responseType: 'arraybuffer'
            }).then(data => {
                resolve(data.data)
            }).catch(error => {
                reject(error.toString())
            })
        })
    }

    export default {
        //   模型库详情页
        name: "modelDetails",
        metaInfo () {
            return {
                title: this.metaTitle,
                meta: [{                 // set meta
                    name: "keywords",
                    content: this.metaKeywords,
                },
                    {                 // set meta
                        name: "description",
                        content: this.metaDescription,
                    }
                ],
            }
        },
        components: {modelView, vueSeamlessScroll, ModelStl, ModelObj, threeD, chatDialog, PayModelDialog},
        data() {
            return {
                activeName: 'first',
                like: false,
                config: {
                    url: window.location.href,
                    disabled: ['douban', 'linkedin', 'diandian', 'qq', 'qzone', 'tencent', 'google', 'twitter', 'tencent', 'weibo']
                },
                sortBox: [],
                sortboxIndex: "0",
                colors: ["#D91E1E", "#D91E1E", "#D91E1E"],
                uuid: "",
                modelDetail: {},
                conmmentList: [],
                swiperList: [
                    {
                        value: '1',
                        img: require('../../assets/模型库/modelDetails1.png')
                    },
                    {
                        value: '2',
                        img: require('../../assets/模型库/modelDetails2.png')
                    },
                    {
                        value: '3',
                        img: require('../../assets/模型库/modelDetails3.png')
                    },
                    {
                        value: '4',
                        img: require('../../assets/模型库/modelDetails4.png')
                    }
                ],
                swiperIndex: 0,
                purchaseRecordList: [],
                moreList: [],
                designer: {},
                current: 1,
                total: 0,
                pageSize: 5,
                form: {},
                base64: null,
                rotation: {
                    x: -Math.PI / 2,
                    y: 0,
                    z: 0,
                },
                loading: true,
                modelDetaLoading: true,
                threeDBox: false,
                // 3D预览
                fileListNew: [],
                innerVisible: false,
                userMessages: {},
                designerLevelList: [],
                modelDownLoading: false,
                mine: 0,
                orderUuid: "",
                metaTitle:'',
                metaKeywords:'',
                metaDescription:'',
            };
        },
        computed: {
            ...mapState({
                isTokenDoor: "isTokenDoor",
                isLogin: "isLogin",
            }),
            defaultOption() {
                return {
                    step: 0.3, // 数值越大速度滚动越快
                    limitMoveNum: this.purchaseRecordList.length, // 开始无缝滚动的数据量
                    hoverStop: true, // 是否开启鼠标悬停stop
                    direction: 1, // 0向下 1向上 2向左 3向右
                    openWatch: true, // 开启数据实时监控刷新dom
                    singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                };
            },
            itemWidth() {
                return 224;
                //rem布局 计算列宽度
                //可以根据自己的rem设置修改这里的 334 值
            },
            gutterWidth() {
                return 20;

                //rem布局 计算x轴方向margin(y轴方向的margin自定义在css中即可)

                //可以根据自己的rem设置修改这里的 36 值
            },
        },
        created() {
            this.uuid = this.$route.query.uuid;
            this.getModelDetail();
            this.getModelOrderByUser();
            this.hasLiked();
            this.getModelOrderList();
            this.commentList();
        },
        filters: {
            ellipsis(value) {
                if (!value) return ''
                if (value.length > 8) {
                    return value.slice(0, 8) + '...'
                }
                return value
            }
        },
        mounted() {
            getNewcurrent()
                .then((res) => {
                    this.userMessages = res;
                    if (res.identity == 'ENTERPRISE' || res.identity == 'STAFF') {
                        this.designer = false;
                    } else {
                        this.designer = true;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        methods: {
            ...mapMutations(["isLoginVuex"]),
            loadMore() {
                console.log('22',);
            },
            orderDownLoad() {
                if (!this.$store.state.isLogin) {
                    this.$message({
                        type: "success",
                        message: "您需要先登录哦！",
                    });
                    this.$router.push({name: "login"});
                    return;
                }
                // console.log(this.designer.userId+'.............'+this.userMessages.uuid)
                if (this.designer.userId == this.userMessages.uuid) {
                    this.$message({
                        type: "info",
                        message: "不能购买自己的模型文件",
                    });
                    return;
                }
              this.upLoadSave()
            },

            thumbnailImgChange(index) {
                this.swiperIndex = index
                if (index > 3) {
                    let scrollbarEl = this.$refs.thumbnailImgRef.wrap
                    scrollbarEl.scrollLeft = index * 190
                }
                this.$refs.carouselRef.setActiveItem(index)
            },
            // changeType(){
            //     this.$refs.modelViewRef.init()
            // },
            // async handleBatchDownload() {
            //     let data = []
            //     let _this = this;
            //     this.modelDetail.urlList.map( file =>{
            //         if(file.fileType ==="FILE"){
            //             let obj = {};
            //             obj.name = file.name;
            //             obj.url = file.modelUrl;
            //             data.push(obj);
            //         }
            //     });
            //     // console.log(data);
            //     const zip = new JSZip()
            //     const cache = {}
            //     const promises = []
            //     for(let i = 0 ; i<data.length; i++) {
            //         let item = data[i];
            //         promises.push(await getFile(item.url).then(data => { // 下载文件, 并存成ArrayBuffer对象
            //             // console.log(data);
            //             zip.file(item.name, data, { binary: true }) // 逐个添加文件
            //             cache[item.name] = data
            //         }))
            //     }
            //     Promise.all(promises).then(() => {
            //         zip.generateAsync({type:"blob"}).then(content => { // 生成二进制流
            //             FileSaver.saveAs(content, this.modelDetail.modelName+new Date().toLocaleString().replace(/年|月|日|上午|下午|:| |\//g, "")+".zip") // 利用file-saver保存文件
            //         })
            //         // this.fullscreenLoading = false;
            //     })
            // },
            upLoadSave() {
                if(this.mine == 0){
                    addOrder({
                        modelUuid: this.modelDetail.uuid,
                        modelName: this.modelDetail.modelName,
                        price: this.modelDetail.price,
                        modelRemark: this.modelDetail.remark,
                        modelImg: this.modelDetail.imgUrl,
                        modelCreatorUuid: this.designer.userId,
                        modelCreatorName: this.designer.nickname,
                        attribute: this.modelDetail.attribute,
                        // modelParams:this.modelDetail.imgUrl,
                    }).then((res) => {
                        if (res.success && res.data != null) {
                            if (this.modelDetail.attribute != 'FREE') {
                                this.$refs.payModelRef.init()
                                window.open(this.$url.payUrl + res.data.orderId, "_blank");
                            } else {
                                this.mine =1;
                                this.handleBatchDownload()
                            }

                        } else {
                            this.$message({
                                type: "info",
                                message: res.message,
                            });
                        }
                    });
                } else if(this.modelDetail.attribute == 'FREE' && this.mine != 0){
                    this.handleBatchDownload()
                } else if(this.modelDetail.attribute == 'PAY' && this.mine == 1){
                    this.handleBatchDownload()
                }

            },
            getModelDetail() {
                // console.log("uuid="+this.uuid)
                getModelDetail({uuid: this.uuid}).then((res) => {
                    this.modelDetail = res;
                    this.metaTitle = res.modelName+"-3D模型库-增材云";
                    this.metaKeywords = res.metaKeywords;
                    this.metaDescription = res.metaDescription;
                    if (
                        this.modelDetail.urlList != null &&
                        this.modelDetail.urlList.length > 0
                    ) {
                        let arr = [];
                        this.modelDetail.urlList.forEach((item, index) => {
                            if (item.fileType === "IMG") {
                                arr.unshift(item);
                            } else if (item.fileType === "FILE") {
                                arr.push(item);
                            }
                        });
                        this.swiperList = arr;
                    }
                    // this.swiperList = this.modelDetail.urlList;
                    // this.swiperList = this.modelDetail.urlList.filter(item =>{return item.fileType==='IMG'})
                    //足迹
                    this.saveVisitorLog();
                    this.getDdesigner();
                    this.getMoreList();
                    // this.designIsLike();
                });
            },
            getModelOrderList() {
                let params = {
                    modelUuid: this.uuid,
                    modelStatus: "PAY",
                    current: 1,
                    pageSize: 20,
                    // isBuy : false
                };

                getModelOrderList(params).then((res) => {
                    let arr = [];
                    // console.log(res)
                    if (res != null && res.list != null && res.list.length > 0) {
                        this.purchaseRecordList = [];
                        res.list.map((item) => {
                            let obj = {};
                            obj.name = item.orderBase.creatorName;
                            obj.name =
                                obj.name.substring(0, 1) + new Array(obj.name.length).join("*");
                            obj.img =
                                item.headImg == (null || "")
                                    ? require("../../assets/设计市场/头像1.jpeg")
                                    : item.headImg;
                            obj.time = getHumanDate(
                                new Date(item.orderBase.createDate).getTime(),
                                true
                            );
                            arr.push(obj);
                        });
                    }
                    this.purchaseRecordList = arr;
                });
            },
            getModelOrderByUser() {
                let params = {
                    modelUuid: this.uuid,
                    modelStatus: "CHANGE",
                    current: 1,
                    pageSize: 20,
                    isBuy: true
                };

                getModelOrderList(params).then((res) => {
                    if (res != null && res.list != null && res.list.length > 0) {
                        res.list.some((item, index) => {
                            this.orderUuid = item.uuid;
                            if (item.modelStatus == 'UN_PAY') {
                                this.mine = 2;
                                return true;
                            } else {
                                this.mine = 1;
                                return true;
                            }
                        });

                    } else {
                        this.mine = 0;
                    }
                });
            },
            getMoreList() {
                let param = {};
                if (this.isLogin) {
                    param = {
                        uuidNotEq: this.uuid,
                        max: 10,
                        status: "RELEASED",
                        typeFirstUuid: this.modelDetail.typeFirstUuid,
                        sortByHot: "1",
                        isLogin: 1,
                    };
                } else {
                    param = {
                        uuidNotEq: this.uuid,
                        max: 10,
                        status: "RELEASED",
                        typeFirstUuid: this.modelDetail.typeFirstUuid,
                        sortByHot: "1",
                        isLogin: 0,
                    };
                }
                getModelList(param).then((res) => {
                    // console.log(res);
                    this.moreList = res;
                    this.modelDetaLoading = false;
                });
            },
            getSortBox(index) {
                this.sortboxIndex = index;
                this.handleCurrentChange(1);
            },
            swiperChange(index) {
                this.swiperIndex = index;
                if (index > 3) {
                    let scrollbarEl = this.$refs.thumbnailImgRef.wrap;
                    scrollbarEl.scrollLeft = index * 190;
                }
            },
            // thumbnailImgChange(index) {
            //     this.swiperIndex = index;
            //     if (index > 3) {
            //         let scrollbarEl = this.$refs.thumbnailImgRef.wrap;
            //         scrollbarEl.scrollLeft = index * 190;
            //     }
            //     this.$refs.carouselRef.setActiveItem(index);
            // },
            // 打包下载文件
            handleBatchDownload() {
                this.modelDownLoading = true
                downloadFile(this.uuid).then((res) => {
                    if (res.headers["error"]) {
                        this.$message.error(decodeURI(res.headers["error"]))
                    } else if (res && res.data) {
                        let zip = window.URL.createObjectURL(new Blob([res.data], {type: "application/zip"}));
                        let fileName = res.headers["content-disposition"].split(";")[1].split("filename=")[1];
                        let s = /\"/g
                        fileName = fileName.replace(s, '')
                        fileName = decodeURI(fileName)  //对文件名decodeURI解码，解决中文名乱码问题
                        const link = document.createElement('a');
                        link.href = zip;
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click()
                        const a = URL.revokeObjectURL(link.href); // 释放
                        this.$message.success("文件打包成功")
                        // 下载记录
                        this.getModelOrderList()
                    }
                    this.modelDownLoading = false

                });

                /*getModelDetail({ uuid: this.uuid }).then( async (res) => {
                let data = [];
                res.urlList.map((file) => {
                  if (file.fileType === "FILE") {
                    let obj = {};
                    obj.name = file.name;
                    obj.url = file.modelUrl;
                    data.push(obj);
                  }
                });
                this.modelDownLoading = true
                try {
                  let modelMess = await downLoad(data, this.modelDetail.modelName + ".zip")

                  if (modelMess == true) {
                    this.$message.success("文件打包成功")

                    this.upLoadSave()

                  } else {
                    this.$message.error("文件打包失败")
                  }
                } catch (error) {
                    this.$message.error("文件打包错误,请联系管理员！")
                }
                this.modelDownLoading = false
              });*/
            },

            getModelDetalis(i) {
                let routeData = this.$router.resolve({
                    name: "modelDetails",
                    query: {
                        uuid: this.moreList[i].uuid,
                    },
                });
                // console.log(routeData)
                window.open(routeData.href, "_blank");
            },
            getDdesigner() {
                designerByUserId(this.modelDetail.creatorUuid).then((res) => {
                    // console.log(res);
                    this.designer = res;
                    getDesignLevel({
                        designerUuid: this.designer.uuid,
                    }).then((res) => {
                        this.designerLevelList = res;
                    });
                });
            },
            hasLiked() {
                hasLiked(this.uuid).then((res) => {
                    this.like = res;
                });
            },
            liked(uuid) {
                if (this.isLogin) {
                    if (this.userMessages.uuid == this.designer.userId) {
                        this.$message({
                            type: "success",
                            message: "不能收藏自己的模型！",
                        });
                        return;
                    }
                    let params = {
                        likeType: "MODEL",
                        serviceType: "LIKE",
                        designerUuid: uuid,
                    };
                    like(params).then((res) => {
                        if (res && res.success) {
                            this.getModelDetail();
                            this.hasLiked();
                            saveModelCollection(uuid).then((res) => {
                                if(this.like){
                                    this.$message({
                                        type: "success",
                                        message: "收藏成功",
                                    });
                                }else{
                                    this.$message({
                                        type: "success",
                                        message: "取消收藏成功",
                                    });
                                }
                            });
                        }
                    });
                } else {
                    this.$message({
                        type: "success",
                        message: "您需要先登录哦！",
                    });
                    this.$router.push("/login");
                }
            },
            getDesigner(uuid) {
                //this.$router.push("/designModel");
                let routeData = this.$router.resolve({
                    name: "designModel",
                    params: {uuid: uuid},
                });
                window.open(routeData.href, "_blank");
            },
            saveVisitorLog() {
                let param = {
                    title: this.modelDetail.modelName,
                    logo: this.modelDetail.imgUrl,
                    visitorType: "MODEL",
                    price: this.modelDetail.price,
                    link: window.location.href,
                };
                saveVisitorLog(param);
            },
            // 分页
            handleCurrentChange(val) {
                this.current = val;
				window.scrollTo(0,0);
                this.commentList();
            },
            commentList() {
                if (this.sortBox.length > 1) {
                    this.form.tags = this.sortBox[this.sortboxIndex].id;
                }
                this.loading = true;
                this.form.uuid = this.uuid;
                this.form.orderType = "MODEL";
                this.form.evaluationType = "NORMAL";
                this.form.current = this.current;
                this.form.pageSize = this.pageSize;
                getEvaluationList(this.form).then((res) => {
                    if (res != null && res.list != null && res.list.length > 0) {
                        this.total = res.total;
                        this.conmmentList = [];
                        if (this.sortBox.length == 0) {
                            this.sortBox.push({
                                name: '全部',
                                num: res.total
                            });
                        }
                        if (this.sortBox.length == 1) {
                            getTagsByGoodsId(this.form).then((res) => {
                                if (res != null && res.length > 0) {
                                    res.forEach((items, index) => {
                                        this.sortBox.push({
                                            id: items.tagUuid,
                                            name: items.tagName,
                                            num: items.evaluationNum,
                                        });
                                    });
                                }
                            });
                        }
                        res.list.forEach((item, index) => {
                            let evaluation = {};
                            evaluation.order = item;
                            evaluation.uuid = item.uuid;
                            evaluation.title = item.creator;
                            evaluation.messages = item.evaluationContent;
                            evaluation.designerStar = parseInt(item.descriptionPoint);
                            evaluation.designerStar2 = parseInt(item.servicePoint);
                            evaluation.designerStar3 = parseInt(item.transportPoint);
                            evaluation.time = item.createTime;
                            evaluation.image = (item.iconUrl ? item.iconUrl : require('../../assets/设计市场/头像1.jpeg'));

                            if (item.addedReplys != null && item.addedReplys.length > 0) {
                                item.addedReplys.some((item, index) => {
                                    if (item.evaluationType == "REPLY") {
                                        evaluation.reply = item.evaluationContent;
                                        return true;
                                    }
                                });
                            }
                            this.conmmentList.push(evaluation);
                        });
                        this.loading = false;
                    } else {
                        this.total = 0;
                        this.loading = false;
                    }
                });
            },
            // 预览3D模型
            changeType(item, type) {
                this.$refs.threeBox.threeAnimal(item, type);
                this.innerVisible = true;
            },
            closeDlog(index) {
                this.innerVisible = index;
            },

            startChat() {
                let targetUserId = this.designer.userId;
                if (this.isLogin) {
                    let user = this.$store.state.isUsermessage;
                    getRongCloudUser(targetUserId).then((res) => {
                        this.$refs.chatDialogRef.init(
                            user.uuid,
                            user.name,
                            user.headUrl,
                            res.uuid,
                            res.name,
                            res.headUrl
                        );
                    });
                } else {
                    this.$message({
                        type: "success",
                        message: "您需要先登录哦！",
                    });
                    this.$router.push("/login");
                }
            },

            saveNewsFabulous() {
                if (!this.$store.state.isLogin) {
                    this.$message.error("用户未登陆");
                    return false;
                }
                let param = {
                    designerUuid: this.modelDetail.uuid,
                    userId: this.userMessages.uuid,
                };
                saveDesignerFabulous(param).then((response) => {
                    this.getModelDetail();
                });
            },
            deleteNewsFabulous() {
                if (!this.$store.state.isLogin) {
                    this.$message.error("用户未登陆");
                    return false;
                }
                let param = {
                    designerUuid: this.modelDetail.uuid,
                    userId: this.userMessages.uuid,
                };
                deleteDesignerFabulous(param).then((response) => {
                    this.getModelDetail();
                });
            },
            creatQrCode() {
                var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                    text: window.location.href, // 需要转换为二维码的内容
                    width: 200,
                    height: 200,
                    colorDark: "#000000",
                    colorLight: "#ffffff",
                    correctLevel: QRCode.CorrectLevel.H,
                });
            },
            handleClick() {
            },
            goPay() {
                // this.$router.push({
                //     path: this.$url.buyerWeb + "/#/modelOrderDetail",
                //     query: {
                //         uuid: this.orderUuid,
                //     },
                // });
                let routeData = "";
                // 跳转模型订单详情页
                routeData = this.$url.buyerWeb + "/#/modelOrderDetail" + "/?uuid=" + this.orderUuid;
                this.$refs.payModelRef.init()
                window.open(routeData, "_blank");
            },
        },
    };
</script>

<style scoped lang="less">
    @import "../../assets/dist/css/share.min.css";

    .choose {
        display: none;
        // position: absolute;
        // top: 73px;
    }

    .iconfont:hover .choose {
        display: block;
    }

    .iconfont:hover {
        color: #7bc549;
        border-color: #7bc549;
    }

    .wechat-qrcode {
        border: 1px solid #eee;
        position: absolute;
        // z-index: 9;
        // top: -164px;
        left: -84px;
        width: 180px;
        height: 192px;
        color: #666;
        font-size: 12px;
        text-align: center;
        background-color: #fff;
        box-shadow: 0 2px 10px #aaa;
        transition: all 0.2s;
        display: flex;
        flex-direction: column;
        align-items: center;

        h4 {
            width: 100%;
            height: 26px;
            line-height: 26px;
            background-color: #f3f3f3;
            margin-bottom: 10px;
        }

        .help {
            text-align: center;

            line-height: 16px;

            span {
                display: inline-block;
                margin-top: 5px;
                text-align: center;
                // line-height: 20px;
            }
        }
    }

    .text span {
        display: block;
    }

    .text i {
        display: block;
        margin-right: 6px;
    }

    .el-carousel {
        // z-index: 2;
    }

    .icon-weixin:before {
        // content: "\E607";
        // position: relative;
    }

    .content {
        /deep/ .el-col-4 {
            width: 20%;
        }
		/deep/ .vue-waterfall {
			 overflow-y: unset;
		  overflow-x: unset;
		}
    }

    .modelDeta {
        /deep/ .el-scrollbar__wrap {
            overflow: scroll;
            height: 100%;
            overflow-x: hidden;
        }

        .modelDeta_loc_top {
            font-size: 14px;
            color: #808080;
            margin: 20px auto 0;
            background: #fff;

            p {
                width: 1200px;
                margin: 0 auto;
                display: flex;
                align-items: center;

                span {
                    color: #808080;
                }
            }
        }

        .modelDeta_topBox {
            background: #fff;
            padding: 10px 0 26px;

            .modelDeta_topBox2 {
                width: 1200px;
                margin: auto;
            }

            .modelDeta_loc {
                font-size: 13px;
                color: #999;

                .modelDeta_loc_title {
                    font-size: 18px;
                    font-weight: bold;
                    color: #262626;
                    letter-spacing: 1px;
                }

                .modelDeta_loc_time {
                    margin: 2px 0 15px;
                }
            }

            .modelDeta_top {
                .modelDeta_top_imgs {
                    width: 734px;
                    height: 533px;
                    margin-right: 26px;
                    flex-shrink: 0;

                    /deep/ .el-carousel__indicators--horizontal {
                        display: none;
                    }

                    /deep/ .el-carousel--horizontal {
                        z-index: 0;
                    }

                    .toolBars {
                        position: absolute;
                        top: 18px;
                        left: 18px;
                        width: 255px;
                        height: 45px;
                        background: rgba(0, 0, 0, 0.2);
                        border-radius: 10px;
                        // z-index: 9;
                        color: #fff;
                        line-height: 45px;
                        padding: 0 10px;
                        box-sizing: border-box;

                        .iconfont {
                            position: relative;
                            z-index: 99999;
                        }

                        ul {
                            display: flex;
                            justify-content: space-between;

                            i {
                                font-size: 22px;
                                cursor: pointer;
                            }

                            .shareHover:hover {
                                z-index: 99999;
                            }
                        }
                    }

                    .shareBox {
                    }

                    .changeType {
                        width: 100px;
                        height: 40px;
                        position: absolute;
                        top: 18px;
                        right: 18px;
                        background: rgba(0, 0, 0, 0.2);
                        border-radius: 10px;
                        z-index: 9;
                        color: #fff;
                        line-height: 40px;
                        padding: 0 10px;
                        box-sizing: border-box;
                        cursor: pointer;

                        img {
                            position: relative;
                            top: 4px;
                            margin-right: 8px;
                        }

                        span {
                            font-size: 14px;
                            font-weight: bold;
                        }
                    }

                    .modelDeta_thumbnailImg {
                        margin-top: 10px;
                        position: relative;

                        ul {
                            display: flex;
                            border-bottom: 1px solid #ddd;
                            padding-bottom: 10px;
                            width: fit-content;

                            li {
                                min-width: 175px;
                                width: 75px;
                                height: 98px;
                                background: #ffffff;
                                border-radius: 4px;
                                margin-right: 15px;
                                cursor: pointer;
                                position: relative;

                                &.active {
                                    &:before {
                                        content: "";
                                        position: absolute;
                                        bottom: -12px;
                                        left: 0;
                                        width: 172px;
                                        height: 2px;
                                        background: #157efb;
                                    }
                                }
                            }
                        }

                        .activeLine {
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            width: 172px;
                            height: 2px;
                            background: #157efb;
                        }
                    }
                }

                .modelDeta_top_content {
                    .top_user {
                        align-items: center;
                        justify-content: space-between;

                        img {
                            width: 66px;
                            height: 66px;
                            border-radius: 50%;
                            margin-right: 15px;
                        }

                        .top_userName {
                            p {
                                font-size: 18px;
                                color: #000000;
                                display: flex;
                                align-items: center;

                                img {
                                    width: 55px;
                                    height: 20px;
                                    margin-left: 5px;
                                    border-radius: 0px;
                                }

                                .top_userName_userName {
                                    height: 21px;
                                }
                            }

                            span {
                                font-size: 12px;
                                margin-top: 15px;
                                color: #262626;
                                display: inline-block;
                                text-align: justify;
                                width: 200px;
                            }
                        }

                        button {
                            border: 1px solid #157efb;
                            border-radius: 5px;
                            width: 50px;
                            height: 30px;
                            margin-left: 30px;
                            background: #fff;
                            color: #157efb;
                            cursor: pointer;
                        }
                    }

                    .modelDes {
                        margin-top: 40px;
                        color: #262626;

                        h4 {
                            margin-bottom: 15px;
                            font-size: 16px;
                        }

                        .modelDes_mess {
                            font-size: 12px;
                            color: #313131;
                            display: inline-block;
                            text-align: justify;
                            // width: 200px;
                        }

                        .modelDes_money {
                            margin: 26px 0;
                            display: flex;
                            align-items: center;

                            h2 {
                                color: #157efb;
                                margin-right: 10px;
                            }

                            // span {
                            //   font-size: 14px;
                            //   color: rgb(193, 193, 193);
                            //   position: relative;
                            //   i {
                            //     position: absolute;
                            //     top: 50%;
                            //     left: 50%;
                            //     transform: translate(-50%, -50%);
                            //     display: inline-block;
                            //     width: 68px;
                            //     height: 1px;
                            //     background: rgb(193, 193, 193);
                            //   }
                            // }
                        }

                        button {
                            border: none;
                            color: #fff;
                            // font-size: 17px;
                            border-radius: 10px;
                            width: 128px;
                            height: 30px;
                            cursor: pointer;
                            background: linear-gradient(180deg, #4377fa 0%, #606aff 100%);
                            padding: 0;
                        }
                    }

                    .model_shop {
                        margin-top: 15px;

                        h4 {
                            margin-bottom: 20px;
                        }

                        .model_shopBIg {
                            padding-right: 17px;
                            height: 200px;
                            overflow: hidden;

                            .model_shop_box {
                                margin-bottom: 22px;
                                font-size: 14px;
                                color: #777;
                                justify-content: space-between;
                                align-items: center;

                                .model_shop_img {
                                    align-items: center;

                                    img {
                                        width: 30px;
                                        height: 30px;
                                        background: #efefef;
                                        border-radius: 50%;
                                        margin-right: 20px;
                                    }

                                    p {
                                    }
                                }

                                .model_shop_time {
                                }
                            }
                        }
                    }
                }
            }
        }

        .box-card {
            margin-bottom: 20px;
            position: relative;
            width: 224px;
            //   border-radius: 6px;

            .image {
                width: 100%;
                display: block;
            }

            .mdfree {
                position: absolute;
                top: 10px;
                left: 10px;
                opacity: 0.6;
                border: none;
                line-height: 20px;
                height: 20px;
                width: 40px;
                text-align: center;
                padding: 0;
                color: #157efb;
            }
        }

        .mdTitle {
            font-size: 16px;
            font-weight: normal;
            color: rgba(0, 0, 0, 0.85);
            margin-bottom: 10px;

            span.mdTime {
                font-size: 12px;
                float: right;
                margin-top: 5px;
                color: #808080 !important;
            }
        }

        .mdDetail {
            font-size: 12px;
            margin-top: 10px;
            color: #808080;
        }

        .mpNum {
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: relative;
            cursor: default;

            span {
                display: inline-block;
                width: 50%;
                text-align: center;
                font-size: 12px;
                height: 50px;
                line-height: 50px;

            }

            span a {
                color: #808080;
                cursor: default;
            }

            span a:hover {
                color: rgba(21, 126, 251, 0.8);
            }
        }

        .mpFooter {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-top: 1px solid #ebeef5;
            margin: 0 -21px -15px;
            padding: 10px 20px;

            /deep/ .el-button {
                color: #157efb;
                border-color: #157efb;
                padding: 6px 10px;
                font-size: 12px;
            }
        }

        .modelDeta_center {
            width: 1200px;
            margin: 30px auto;
            background: #fff;
            padding: 20px 24px;
            border-radius: 5px;
            box-sizing: border-box;

            .modelDeMess {
                margin-bottom: 16px;
                font-size: 14px;
                // display: flex;
                &:nth-of-type(1) {
                    margin-top: 20px;
                }

                p:nth-of-type(1) {
                    margin-bottom: 20px;
                }
            }

            .modelDeta_centerBox {
                // justify-content: space-between;
                align-items: center;

                .modelDeta_center_title {
                    font-size: 18px;
                    color: #262626;
                    font-weight: bold;
                    letter-spacing: 1px;
                }

                i {
                    color: #999;
                }
            }

            .modelDeta_centerMess {
                padding: 15px 0;
                color: #888;
            }

            .additional_evaluation {
                font-size: 14px;
                color: #af874d;
                width: 80%;
                margin-bottom: 20px;
                line-height: 24px;
                background: #efefef7a;
                border-radius: 10px;
                padding: 20px;
            }

            .blue {
                color: #1181ff;
            }

            .right_sortbox {
                font-size: 14px;
                height: 32px;
                line-height: 32px;
                margin-bottom: 15px;
                margin-top: 20px;

                p {
                    cursor: pointer;
                    margin-right: 40px;
                    padding: 0 10px;
                }

                .p_active {
                    color: #1181ff;
                    background: #f3f8ff;
                    border-radius: 8px;
                }
            }

            .right_sortbox2 {
                font-size: 14px;
                height: 32px;
                line-height: 32px;
                margin-bottom: 15x;

                p {
                    cursor: pointer;
                    margin-right: 40px;
                    padding: 0 10px;
                    background: #f5f5f5;
                    border-radius: 10px;
                }
            }

            .comList {
                border-radius: 10px;
                width: 100%;
                padding: 15px 0;
                box-sizing: border-box;
                -moz-box-sizing: border-box; /* Firefox */
                -webkit-box-sizing: border-box; /* Safari */
                margin-top: 15px;
                justify-content: space-between;

                .comList_img {
                    width: 55px;
                    height: 55px;
                    background: #efefef;
                    border-radius: 50%;
                    margin-right: 15px;

                    img {
                        width: 55px;
                        height: 55px;
                        border-radius: 50%;
                    }
                }

                .comList_con {
                    color: #777;
                    margin-right: 10px;

                    .con_title {
                        font-size: 14px;
                        margin-bottom: 5px;
                        color: #262626;
                    }

                    .con_mess {
                        font-size: 14px;
                        color: #262626;
                    }

                    span {
                        color: #b8b8b8;
                        font-size: 12px;
                    }
                }

                .comList_star {
                    flex-shrink: 0;

                    .comList_star_A {
                        align-content: center;
                        margin-bottom: 3px;

                        span {
                            color: #b8b8b8;
                            font-size: 13px;
                            margin-right: 5px;
                            line-height: 22px;
                        }
                    }
                }
            }
        }

        .modelDeta_bottom {
            width: 1200px;
            margin: 20px auto 0;
            background: #fff;
            padding: 20px 0 0 0;
            border-radius: 5px;
            box-sizing: border-box;

            .modelDeta_bottom_title {
                font-size: 18px;
                color: #262626;
                padding: 0 0 20px 24px;
                font-weight: bold;
                letter-spacing: 1px;
                // padding-bottom: 20px;
            }

            .modelDeta_box_img {
                align-items: center;
                flex-wrap: wrap;

                .modelDeta_bottom_img {
                    position: relative;
                    width: 262px;
                    height: 194px;
                    border-radius: 4px;
                    background: #ffffff;
                    cursor: pointer;
                    margin: 0 34px 38px 0;

                    &:nth-of-type(4n + 1) {
                        margin-right: 0;
                    }

                    &:hover {
                        .modelDeta_bottom_Info {
                            display: block;
                        }
                    }

                    img {
                        width: 100%;
                        height: 100%;
                        border-radius: 4px;
                    }

                    .modelDeta_bottom_Info {
                        display: none;
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        background: #000000;
                        opacity: 0.56;
                        height: 50px;
                        width: 100%;
                        color: #fff;
                        padding: 10px;
                        box-sizing: border-box;
                        font-size: 12px;
                        line-height: 30px;

                        .type {
                            width: 50%;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }

                        .info {
                            display: flex;

                            img {
                                width: 20px;
                                height: 20px;
                                border-radius: 50%;
                                position: relative;
                                top: 5px;
                            }

                            .name {
                                max-width: 102px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                padding-left: 8px;
                                box-sizing: border-box;
                            }
                        }
                    }
                }

                .modelDeta_bottom_img2 {
                    width: 262px;
                    height: 0;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/model/modelDetails.vue